export const VALUES = [
    {display:'January',    value:'1'},
    {display:'February',   value:'2'},
    {display:'March',      value:'3'},
    {display:'April',      value:'4'},
    {display:'May',        value:'5'},
    {display:'June',       value:'6'},
    {display:'July',       value:'7'},
    {display:'August',     value:'8'},
    {display:'September',  value:'9'},
    {display:'October',    value:'10'},
    {display:'November',   value:'11'},
    {display:'December',   value:'12'}
]

export const COUPON_MONTHS = VALUES
    .map(({value, display}) => {
        return {
            label: display,
            display,
            value: 'holdCouponPayMonths=' + value
        }
    })

export const COUPON_MONTH_LABELS = Object.fromEntries(VALUES.map(a=> [a.value,a.display]))
